export const PROJECT_LOGO_MAX_SIZE = 1e6;
